export const initModalDialogModelB = () => {
    // @ vars ---------------------------------------------------------------
    const dlg_model_b = document.getElementById('modal-dialog-model-b')

    if (!dlg_model_b) {
        return
    }

    const btn_dlg_close = dlg_model_b.querySelector('.modal-dialog-close')
    const btn_page_dst = dlg_model_b.querySelector('.btn-page-dst')
    const ajax_url = '/' + BB_DIR_WEBROOT + '/index.php/tools/packages/model_b/ajax.php'

    // @ funcs ---------------------------------------------------------------
    const openDlgModelB = () => {
        document.body.classList.add('no-scroll')
        dlg_model_b.style.display = 'block'
    }

    const closeDlgModelB = () => {
        const fetch_url = buildUrl(ajax_url, { action: 'hide modal dialog model b' })

        fetch(fetch_url, { method: 'GET' })
            .then((response) => response.json())
            .catch((error) => console.error('Fetch error:', error))

        document.body.classList.remove('no-scroll')
        dlg_model_b.style.display = 'none'
    }

    const buildUrl = (baseUrl, params = {}) => {
        const queryString = new URLSearchParams(params).toString()
        return queryString ? `${baseUrl}?${queryString}` : baseUrl
    }

    // @ events ---------------------------------------------------------------
    btn_dlg_close.addEventListener('click', (e) => {
        e.preventDefault()
        closeDlgModelB()
    })

    btn_page_dst.addEventListener('click', (e) => {
        e.preventDefault()
        closeDlgModelB()
        window.location = btn_page_dst.getAttribute('href')
    })

    document.addEventListener('click', (e) => {
        if (e.target.closest('.modal-dialog-model-b') === null) {
            closeDlgModelB()
        }
    })

    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            closeDlgModelB()
        }
    })

    // @ inits ---------------------------------------------------------------
    openDlgModelB()
}
